import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'node_modules/rxjs';

import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root',
})
export class ResumeUploadService {
  recruiterdashboardUrl = environment.recruiterdashboardUrl;
  parserResumeUrl = environment.parserResumeUrl;
  // profileUrl = environment.profileUrl;
  // resumeUrl = environment.resumeUrl;
  candidateHiringNameUrl = environment.candidateHiringNameUrl;
  companyHiringType = localStorage.getItem('fresherCompHiringTypeId');
  constructor(private http: HttpClient) {}

  uploadResume(resumeObj: any): Observable<any> {
    const requestOptions: object = {
      reportProgress: true,
      observe: 'response',
      'Content-Type': 'multipart/form-data',
    };
    return this.http.post<any>(this.parserResumeUrl + 'upload', resumeObj, requestOptions);
  }

  getSourceDetails(reqNo) {
    let params = new HttpParams();
    // params = params.append('requisitionId', '7071');
    params = params.append('requisitionId', reqNo);
    const options = { headers: new HttpHeaders().set('Content-Type', 'application/json'), params: params };
    return this.http.get<any>(this.recruiterdashboardUrl + 'getSourceDetailsByReqId', options);
  }

  getRequisitionsbyIdorName(val: any): Observable<any> {
    console.log(val);
    let _params = new HttpParams();
    _params = _params.append('requestParam', val);
    // params = params.append('skillId', body.skills);
    const body = {
      companyHiringTypeId: this.companyHiringType,
      requisition: val,
    };
    return this.http.post<any>(this.candidateHiringNameUrl + 'candidate/forwardNext', body);

    // return this.http.post<any>('https://intaptest.infosysapps.com/infosys/intapcandidate/v1/candidate/forwardNext',body)
  }
  getRequisitionsforUpdateOffer(val: any): Observable<any> {
    console.log(val);
    let _params = new HttpParams();
    _params = _params.append('requestParam', val);
    // params = params.append('skillId', body.skills);
    const body = {
      companyHiringTypeId: +this.companyHiringType,
      requisition: val,
    };
    return this.http.post<any>(this.candidateHiringNameUrl + 'candidate/forwardNext', body);

    // return this.http.post<any>('https://intaptest.infosysapps.com/infosys/intapcandidate/v1/candidate/forwardNext',body)
  }
}
